import { ModalBackground, ModalCard } from "../hometab/styles";
import SubmitButton from "../../atoms/submitbutton";
import { useState } from "react";
import { Heading, Info, Input } from "./styles";
import { yupResolver } from "@hookform/resolvers/yup";
import { useSelector } from "react-redux";
import * as yup from "yup";
import { toast } from "react-toastify";
import axios from "axios";
import { API_URL } from "../../../constants";
import { useForm } from "react-hook-form";
import { contactSchema } from "../../../validations/contact";

type FormData = yup.InferType<typeof contactSchema>;

interface ContactProps {
  toggleClear: () => void;
  contact: any;
  refresh: boolean;
  setRefresh: any;
}
export function ContactModal({ toggleClear, contact, refresh, setRefresh }: ContactProps) {
  const [isloading, setisloading] = useState(false);
  let businessUuid = useSelector((state: any) => state.auth.uuid);

  const { register, handleSubmit, formState, reset } = useForm<FormData>({
    resolver: yupResolver(contactSchema),
    defaultValues: {
      email: contact?.email,
      whatsapp: contact?.whatsappUrl.match(/\d+/),
    },
  });
  const { errors } = formState;

  const createRequest = (data: any) => {
    setisloading(true);
    let num = null;
    if (data?.whatsapp.length === 11) {
      num = data?.whatsapp.slice(1);
    } else {
      num = data.whatsapp;
    }

    let formData: any = {
      businessUuid: businessUuid,
      email: data?.email,
      whatsappUrl: `https://wa.me/${num}`,
    };

    axios
      .post(`${API_URL}/update/contact`, formData)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          setisloading(false);
          toast.success(response.data.message);
          reset();
          toggleClear();
          setRefresh(!refresh);
        }
      })
      .catch((error) => {
        setisloading(false);

        if (error?.response?.status === 400 || error?.response?.status === 401) {
          toast.error(error?.response?.data?.message);
          return;
        }
        toast.error("Connection Failed");
      });
  };

  return (
    <ModalBackground onClick={toggleClear}>
      <ModalCard onClick={(event) => event.stopPropagation()}>
        <div>
          <Heading>Contact Information</Heading>
          <Info>Add Atleast One Contact Information</Info>
          <form onSubmit={handleSubmit(createRequest)}>
            <Input type="text" placeholder="Email" {...register("email")} />
            {errors?.email && <p className="text-xs mb-2 text-red-600">{errors.email?.message}</p>}
            <Input type="text" placeholder="Whatsapp Number" {...register("whatsapp")} />
            {errors?.whatsapp && <p className="text-xs mb-2 text-red-600">{errors.whatsapp?.message}</p>}
            <SubmitButton isloading={isloading} value="Save" width="19.6em" />
          </form>
        </div>
      </ModalCard>
    </ModalBackground>
  );
}
